"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosBatchCreateInputSchema = exports.APosBatchSchema = exports.APosBatchStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosBatchStatusSchema = zod_1.z.enum(['available', 'reserved', 'expired', 'depleted']);
exports.APosBatchSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    batchId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    batchNumber: zod_1.z.string().min(1).max(50),
    expiryDate: zod_1.z.number().optional(),
    manufactureDate: zod_1.z.number().optional(),
    initialQuantity: zod_1.z.number().int().positive(),
    currentQuantity: zod_1.z.number().int().nonnegative(),
    reservedQuantity: zod_1.z.number().int().nonnegative().default(0),
    unitCost: zod_1.z.number().nonnegative(),
    receivedAt: zod_1.z.number(),
    fifoRank: zod_1.z.number().int().nonnegative(),
    grnId: id_schema_1.EntityIdSchema.optional(),
    purchaseOrderId: id_schema_1.EntityIdSchema.optional(),
    supplierId: id_schema_1.EntityIdSchema.optional(),
    status: exports.APosBatchStatusSchema.default('available'),
    notes: zod_1.z.string().max(500).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosBatchCreateInputSchema = zod_1.z.object({
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    batchNumber: zod_1.z.string().min(1).max(50),
    expiryDate: zod_1.z.number().optional(),
    manufactureDate: zod_1.z.number().optional(),
    initialQuantity: zod_1.z.number().int().positive(),
    unitCost: zod_1.z.number().nonnegative(),
    grnId: id_schema_1.EntityIdSchema.optional(),
    purchaseOrderId: id_schema_1.EntityIdSchema.optional(),
    supplierId: id_schema_1.EntityIdSchema.optional(),
    notes: zod_1.z.string().max(500).optional(),
});
//# sourceMappingURL=batch.schema.js.map